import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  gap: 35px;
  margin-top: 15px;
`;

export const AdsListContainer = styled.div`
  width: 100%;
  margin-bottom: 30px;
`;
